import { gql } from "@apollo/client";

export const GetProjectExts = gql`
  query GetProjectExts(
    $token: String!
    $customerID: ID!
    $empID: ID!
    $projectID: ID!
    $after: Cursor
    $first: Int
    $orderBy: AtsAcLdgrProjectExtOrder
    $name: String
  ) {
    GetProjectExts(
      token: $token
      customerID: $customerID
      empID: $empID
      projectID: $projectID
      after: $after
      first: $first
      orderBy: $orderBy
      where: { or: [{ nameContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          name
          projectScope
          contractSignedWith
          loa
          agreementDate
          startDate
          endDate
          agreementFile
          endAgreementFile
          customerID
          ldgrID
          projectID
          supplierName {
            id
            desc
            supplier_details {
              state
              email
              phone
              gstNo
              proficiency
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetProjectExtByNodeId = gql`
  query GetProjectExtByNodeId($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsAcLdgrProjectExt {
        id
        name
        agreementDate
        projectScope
        contractSignedWith
        loa
        agreementDate
        startDate
        endDate
        agreementFile
        endAgreementFile
        customerID
        ldgrID
        supplierName {
          id
          desc
          supplier_details {
            state
            email
            phone
            gstNo
            proficiency
          }
        }
      }
    }
  }
`;
